import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	signingIn: false,
	signedIn: false,
	signInCancelled: false,
	signingOut: false,
	error: null,
	errorCode: null,
	accessToken: null,
};

const saveTokenValues = (state, action) => {
	const { data } = action.payload;

	state.accessToken = data.data;
};

const slice = createSlice({
	name: "@auth",
	initialState,
	reducers: {
		signInBegin: (state, action) => {
			state.error = null;
			state.errorCode = null;
			state.signingIn = true;
			state.signInCancelled = false;
		},
		signInSuccess: (state, action) => {
			state.signingIn = false;
			state.signedIn = true;
			if (!state.signInCancelled) {
				saveTokenValues(state, action);
			}
			state.error = null;
			state.errorCode = null;
		},
		signInFailure: (state, action) => {
			state.signingIn = false;
			state.error = action.payload.error;
			state.errorCode = action.payload.code;
			state.signInCancelled = false;
		},
		signOutSuccess: (state, action) => {
			state.signedIn = false;
			state.accessToken = null;
			state.signingOut = false;
		},
	},
});

export const { signInBegin, signInSuccess, signInFailure, signOutSuccess } = slice.actions;

export default slice.reducer;
